import createEmotion from '@emotion/css/create-instance';

/**
 * Custom @emotion/css instance with a shared insertionPoint.
 * This ensures styles are injected after AntD's extracted CSS (loaded via <link>),
 * fixing dev/prod CSS ordering differences.
 *
 * Import css/cx/etc from this module instead of '@emotion/css' to get consistent behavior.
 */
export const emotionCssInsertionPoint = document.createElement('meta');
emotionCssInsertionPoint.setAttribute('name', 'emotion-css-insertion-point');
emotionCssInsertionPoint.setAttribute('content', '');
document.head.appendChild(emotionCssInsertionPoint);

const { css, cx, injectGlobal, keyframes, hydrate, flush, cache } = createEmotion({
  key: 'fbcss',
  insertionPoint: emotionCssInsertionPoint,
});

export { css, cx, injectGlobal, keyframes, hydrate, flush, cache };
